import { UIImage } from '../common/ui/uiImage';
import { UIPanel } from '../common/ui/uiPanel';
import { UIScreen, UIScreenOptions } from '../common/ui/uiScreen';
import { UIText } from '../common/ui/uiText';
import { LoadingBar } from '../common/loadingBar';
import { Game } from './game';
// import { GameStyle } from './gameStyle';


export class SplashScreen extends UIScreen {
  protected loadingBar: LoadingBar;

  public build() {
    let background = new UIPanel({
      fitParent: {left: 0, right: 0, top: 0, bottom: 0},
      gradient: {
        startColor: '#b9967b',
        endColor: '#512701',
        type: 'vertical'
      },
      parent : this
    });

    var sky = new UIPanel({
      fitParent: {left: 0, right: 0, top: -1, bottom: -1},
      color: '#4d85bd',
      size: {x: 0, y: 200},
      parent : this
    });

    let logo = new UIImage({
      url : require('./assets/logo.png'),
      position: {x: 0, y: 50},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      parent : this
    });

    this.loadingBar = new LoadingBar({
      anchor: {x: 0.5, y: 1},
      pivot: {x: 0.5, y: 1},
      position: {x: 0, y: -60},
      size: {x: 250, y: 10},
      visible: false,
      parent: this
    });

    let copyright = new UIText({
      text: 'Copyright 2023, Monster Ideas Inc.',
      fontFamily: 'Arial',//GameStyle.fonts.small.family,
      fontSize: 16, //GameStyle.fonts.small.size,
      color: '#ffffff80',
      anchor: {x: 0.5, y: 1},
      pivot: {x: 0.5, y: 1},
      position: {x: 0, y: -20},
      parent: this
    });
  }

  public onWake() {
    this.loadingBar.visible = true;
    this.loadingBar.start();

    this.waitFor(2000, ()=>{
      Game.instance.gameScreen.show();
    });
  }
}